import { memo } from 'react';
import getConversionType from './getConversionType';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const defaultFormat = value => value;
const defaultFormatValue = value => value;
const Conversion = ({
  value,
  one,
  some,
  many,
  zero = '',
  formatValue = defaultFormatValue,
  format = defaultFormat,
  hasValue = true
}) => {
  if (value === 0) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: format(zero)
    });
  }
  const conversionType = getConversionType({
    one,
    some,
    many,
    value
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: hasValue ? /*#__PURE__*/_jsxs("span", {
      suppressHydrationWarning: true,
      children: [formatValue(value), "\xA0", format(conversionType)]
    }) : /*#__PURE__*/_jsx("span", {
      suppressHydrationWarning: true,
      children: format(conversionType)
    })
  });
};
export default /*#__PURE__*/memo(Conversion);
//# sourceMappingURL=Conversion.js.map